import*as r from"react";import{Icon as e}from"./utils/index.js";var t=function(t,o){return r.createElement(e,o,r.createElement("path",{fill:"currentColor",d:t}))};export{t as c};
//# sourceMappingURL=createSvgIcon-53affdc2.js.map
